import React from 'react'
export const IconList: React.FC = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16">
      <title>listAlt</title>
      <path d="M2 7.333h3.333c0.368 0 0.667-0.298 0.667-0.667v0-3.333c0-0.368-0.298-0.667-0.667-0.667v0h-3.333c-0.368 0-0.667 0.298-0.667 0.667v0 3.333c0 0.368 0.298 0.667 0.667 0.667v0zM2.667 4h2v2h-2v-2zM2 13.333h3.333c0.368 0 0.667-0.298 0.667-0.667v0-3.333c0-0.368-0.298-0.667-0.667-0.667v0h-3.333c-0.368 0-0.667 0.298-0.667 0.667v0 3.333c0 0.368 0.298 0.667 0.667 0.667v0zM2.667 10h2v2h-2v-2zM7.333 2.667h7.333v1.333h-7.333zM7.333 5.333h5.333v1.333h-5.333zM7.333 8.667h7.333v1.333h-7.333zM7.333 11.333h5.333v1.333h-5.333z"></path>
    </svg>
  )
}
